import { css, MAGNETIC_TOKENS } from '@appd/uik';

export enum HealthStatusLabel {
  Healthy = 'Healthy',
  Unhealthy = 'Unhealthy',
  Warning = 'Warning',
  Unknown = 'Unknown',
  NoAlertRulesEnabled = 'NoAlertRulesEnabled',
}

const {
  COLORS: {
    CONTROL_BG_MEDIUM_DISABLED,
    DEFAULT_BG_STRONG_DISABLED,
    NEGATIVE_BG_MEDIUM,
    NEGATIVE_BG_DISABLED,
    POSITIVE_BG_MEDIUM,
    POSITIVE_BG_DISABLED,
    WARNING_BG_MEDIUM,
    WARNING_BG_DISABLED,
    CONTROL_BG_STRONG_DISABLED,
  },
} = MAGNETIC_TOKENS;

const BACKGROUND_COLOR_MAPPING = {
  Healthy: POSITIVE_BG_MEDIUM,
  Warning: WARNING_BG_MEDIUM,
  Unhealthy: NEGATIVE_BG_MEDIUM,
  Unknown: CONTROL_BG_MEDIUM_DISABLED,
  NoAlertRulesEnabled: CONTROL_BG_STRONG_DISABLED,
};

const BACKGROUND_HOVER_COLOR_MAPPING = {
  Healthy: POSITIVE_BG_DISABLED,
  Warning: WARNING_BG_DISABLED,
  Unhealthy: NEGATIVE_BG_DISABLED,
  Unknown: DEFAULT_BG_STRONG_DISABLED,
  NoAlertRulesEnabled: CONTROL_BG_STRONG_DISABLED,
};

export const getSingleTagStyles = (status: HealthStatusLabel): string =>
  css({
    backgroundColor: BACKGROUND_COLOR_MAPPING[status],
    maxWidth: '110px',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: BACKGROUND_HOVER_COLOR_MAPPING[status],
    },
  });
